import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsappWidget = ({ phoneNumber, message }) => {
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message || "Hello!"
  )}`;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-green-500 rounded-full p-3 shadow-xl hover:scale-110 transition-transform flex items-center justify-center"
      >
        <FaWhatsapp className="text-white w-8 h-8" />
      </a>
    </div>
  );
};

export default WhatsappWidget;
